import { Formats, Options } from 'intl-messageformat';
import { Locale } from './core/interfaces/Locale';
import type { TranslationDefinition } from './core/interfaces/TranslationDefinition';
import { MessageFormatter } from './MessageFormatter';

export function translate<TranslationKey extends string>(
  definitions:
    | Record<TranslationKey, TranslationDefinition>
    | TranslationDefinition<TranslationKey>[]
): Record<TranslationKey, string> {
  return definitions as any;
}

export function translateFormatter<Props extends Record<string, any>>(
  definition: TranslationDefinition,
  overrideFormats?: Partial<Formats>,
  options?: Options,
  locale?: Locale
): MessageFormatter<Props> {
  return new MessageFormatter(
    definition as unknown as string, // replaced by i18nLoader
    locale as Locale, // replaced by i18nLoader
    overrideFormats,
    options
  );
}
